import { PASS_TYPE_SEASON, PASS_TYPE_STAFF } from '@domain/passes';
import { EVENT_REPORT_PASS_TYPE } from '@pages/events/utils/reports-utils/config';

export const getDefaultPassNameTranslation = (type: string) => {
  if (type === PASS_TYPE_STAFF) return 'passes:staffLabelType';
  if (type === PASS_TYPE_SEASON || type === EVENT_REPORT_PASS_TYPE) return 'passes:seasonLabelType';

  return '';
};
